import React from 'react';
import { Text, TextProps} from 'react-native';
import {THEME_COLORS, FONT_SIZE, FONT_FAMILY} from '../themes';

interface CustomTextInterface extends TextProps{
    children:string|any;
    fontSize?:"x-small" | 'small' | 'medium' | 'large' | 'x-large';
    fontFamily?:string;
    style?:any;
    type_of_six?: "one_six"| "two_six" | "three_six" | "four_six" | "five_six" | "six_six"
}

const CustomTextComponent=(props: CustomTextInterface)=>{

    let { style, children, fontSize: inputFontSize, fontFamily, type_of_six } = props;
    const passedStyle = Array.isArray(style) ? style : [style];
    let fontSize = '18px';
    fontSize = inputFontSize === 'x-small' ? FONT_SIZE.s0 : inputFontSize === 'small' ? FONT_SIZE.s1 : inputFontSize === 'medium' ? FONT_SIZE.s2 : inputFontSize === 'large' ? FONT_SIZE.s3 : inputFontSize === 'x-large' ? FONT_SIZE.s4 : FONT_SIZE.s2;
    let customStyle = null;
    if (type_of_six === "one_six"){
        customStyle = {fontFamily: FONT_FAMILY.one,
                        fontSize: fontSize
                        }
    } else if (type_of_six === "two_six") {
        customStyle = {fontFamily: FONT_FAMILY.two,
            fontSize
        }
    } else if (type_of_six === "three_six") {
        customStyle = {fontFamily: FONT_FAMILY.three,
            fontSize
        }
    } else if (type_of_six === "four_six") {
        customStyle = {fontFamily: FONT_FAMILY.four,
            fontSize
        }
    } else if (type_of_six === "five_six") {
        customStyle = {fontFamily: FONT_FAMILY.five,
            fontSize
        }
    } else {
        customStyle = {
            fontFamily: FONT_FAMILY.two,
            fontSize
        }
    }

    return (
        <>
            <Text
                {...props}
                style={[customStyle, ...passedStyle,]}
            >
                {children ?? ""}
            </Text>
        </>
    )
}

export default CustomTextComponent;
